<template>
    <div class="Header">
        <button @click="back()" aria-label="Back" class="Header__back">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="31" viewBox="0 0 10 21">
                <defs>
                    <path id="icon-arrow-a" d="M10.9143125,24.1672708 L9.9999375,23.3437917 L18.5205625,14.5006042 L9.9999375,5.6568125 L10.9143125,4.83333333 L19.8318125,14.0885625 C20.0555625,14.3205625 20.0555625,14.6800417 19.8318125,14.9120417 L10.9143125,24.1672708 Z"/>
                </defs>
                <g fill="none" fill-rule="evenodd" transform="matrix(-1 0 0 1 20 -4)">
                    <mask id="icon-arrow-b" fill="#fff">
                        <use xlink:href="#icon-arrow-a"/>
                    </mask>
                    <use fill="#656363" xlink:href="#icon-arrow-a"/>
                    <g fill="#004346" mask="url(#icon-arrow-b)">
                        <rect width="30" height="29"/>
                    </g>
                </g>
            </svg>
        </button>
        <a href="https://www.suncorp.com.au/insurance/life.html">
            <img src="../assets/suncorp.svg" alt="Suncorp logo, select to return to homepage" class="Header__logo" @click="reset"/>
        </a>
    </div>
</template>

<script>
    export default {
        methods: {
            path() {
                if (this.$route.path == '/') {
                    return false;
                } else {
                    return true;
                }
            },
            back() {
                if ((this.$route.path == '/income/detailed/' || this.$route.path == '/life/detailed/' ) && this.$store.state.step > 1) {
                    this.$store.commit('update', { name: 'step', value: this.$store.state.previous });
                } else {
                    this.$router.go(-1)
                }
            },
            reset() {
                if (this.$store.state.product) {
                    this.$router.push(`/${this.$store.state.product}`);
                    this.$store.commit('reset');
                }
            }
        }
    }
</script>

<style scoped>
    .Header {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 12px 25px;
        background-color: #fff;
        border-bottom: 2px solid #004346;

        @media screen and (min-width: 768px) {
            padding: 15px 25px;
        }
    }

    @media screen and (min-width: 768px) {
        .Header {
            padding: 11px;
        }
    }

    .Header__back {
        position: absolute;
        left: 20px;
        top: calc(50% - 15px);
        cursor: pointer;
        height: 35px;
        background-color: transparent;
        border: none;

        @media screen and (min-width: 768px) {
            width:auto;
            height: auto;
        }
    }

    .Header__logo {
        height: 42px;
        cursor: pointer;

        @media screen and (min-width: 768px) {
            height: 63px;
        }
    }
</style>
